import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import DoubleMetricCard from "../DoubleMetricCard";
import BannerRibbon from "../BannerRibbon";

const HousingMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const orders = getMetricGroupOrderIds(tab);

    const sortedHousingMetrics = orders.map((order: number[]) => 
        categorizedData.Housing
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Housing metrics:', sortedHousingMetrics);

    const h: DisaggregatedMetric[] = sortedHousingMetrics[0];
    const h2: DisaggregatedMetric[] = sortedHousingMetrics[1];
    const h3: DisaggregatedMetric[] = sortedHousingMetrics[2];

    const ownerCostBurden = h3.find(metric => metric.id === 232) || null;
    const renterCostBurden = h3.find(metric => metric.id === 231) || null;

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }


    return (
        <>  
            <div className="mb-2">
                <BannerRibbon text="Housing Indicators" color="#225591"/>
            </div> 
            <p className="text-port-text mx-4 text-[10px] mb-4">Data updates published July 15, 2025. Data testing in progress.</p>
            <div className="grid grid-cols-2 gap-4 place-items-start ml-4">
                {h.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}

                <div className="col-span-2 m-auto pr-12">
                {renterCostBurden && ownerCostBurden && (
                <DoubleMetricCard 
                    key={231}
                    metricOne={renterCostBurden}
                    metricTwo={ownerCostBurden}
                    title="Share of Households that are Cost-Burdened"
                    metadataId={231}
                    width="w-full"
                    svg={getSvgMap(231)}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
                )}
                </div>

                {h2.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>
        </>
    );
}

export default HousingMetrics;